import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=3b22c5ce&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.css?vue&type=style&index=0&id=3b22c5ce&prod&scoped=true&lang=css&"
import style1 from "./Button.vue?vue&type=style&index=1&id=3b22c5ce&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b22c5ce",
  null
  
)

export default component.exports